import React, { Fragment, useState } from 'react';
import { Button, Modal } from 'antd';
import { confirmUpdate } from '../popup/confirm';
import ModalCreateOrder from '../popup/ModalCreateOrder';
import ModalCreateTemplate from '../popup/ModalCreateTemplate';

const confirm = Modal.confirm;

const BtnFormSubmit = ({ onClick, onClickTemplate, disabled, typeForm }) => {
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalTemplate, setVisibleModalTemplate] = useState(false);
  const confirmShow = () => {
    confirm({
      ...confirmUpdate,
      onOk: onClick,
    });
  };
  const closeModal = () => {
    setVisibleModal(false);
  };
  const showModal = () => {
    setVisibleModal(true);
  };
  const closeModalTemplate = () => {
    setVisibleModalTemplate(false);
  };
  const showModalTemplate = () => {
    closeModal();
    setVisibleModalTemplate(true);
  };
  const formSubmit = () => {
    closeModal();
    onClick();
  };
  const formSubmitTemplate = templateName => {
    closeModalTemplate();
    onClickTemplate(templateName);
  };

  return (
    <Fragment>
      <Button
        type="primary"
        htmlType="submit"
        size="large"
        className="offers-create__submit"
        disabled={disabled}
        onClick={
          typeForm === 'edit'
            ? confirmShow
            : typeForm === 'create'
            ? showModal
            : onClick
        }
      >
        {typeForm === 'edit' ? 'Сохранить' : 'Оформить заказ'}
      </Button>
      <ModalCreateOrder
        visibleModal={visibleModal}
        closeModal={closeModal}
        openSaveTemplate={showModalTemplate}
        formSubmit={formSubmit}
      />
      {/*<ModalCreateTemplate*/}
      {/*  visibleModal={visibleModalTemplate}*/}
      {/*  closeModal={closeModalTemplate}*/}
      {/*  formSubmit={formSubmitTemplate}*/}
      {/*/>*/}
    </Fragment>
  );
};

export default BtnFormSubmit;
